// extracted by mini-css-extract-plugin
export var displayNone = "_uf-6";
export var imgContainer = "_uf-2";
export var overflowHidden = "_uf-3";
export var productInfoCardButtonContainer = "_uf-5";
export var productTitleText = "_uf-4";
export var rightArrow = "_uf-1";
export var rightArrowContainer = "_uf-0";